{
    "image_upload_error": "Error al subir la imagen. Vuelve a cargar esta página y selecciona la imagen de nuevo.",
    "search_placeholder": "Buscar fotos e ilustraciones",
    "search": "Buscar",
    "photo": "Imagen",
    "image_by": "por",
    "free_photos_from": "Imágenes de archivo gratuitas de",
    "uploading": "Subiendo",
    "cancel": "Cancelar",
    "select": "Seleccionar"
}
